import React from "react";
import Reveal from "./Reveal";

export default function PageHeader({ eyebrow, title, accent, subtitle, image }) {
  return (
    <section className="relative pt-32 md:pt-40 pb-16 md:pb-24 overflow-hidden">
      {image && (
        <div className="absolute inset-0 pointer-events-none">
          <img src={image} alt="" className="w-full h-full object-cover opacity-30" />
          <div className="absolute inset-0 cinema-overlay" />
        </div>
      )}
      <div className="relative max-w-7xl mx-auto px-4 md:px-8">
        <Reveal>
          <span className="eyebrow">{eyebrow}</span>
          <h1 className="mt-4 text-5xl sm:text-6xl md:text-7xl font-extrabold leading-[0.95] balanced">
            {title}
            {accent && (
              <>
                {" "}
                <span className="font-script text-yellow-brand text-glow-yellow text-6xl sm:text-7xl md:text-8xl">
                  {accent}
                </span>
              </>
            )}
          </h1>
          {subtitle && (
            <p className="mt-6 text-white/65 text-lg md:text-xl max-w-2xl leading-relaxed">{subtitle}</p>
          )}
        </Reveal>
      </div>
    </section>
  );
}
